import { render, staticRenderFns } from "./SocialCounter.vue?vue&type=template&id=63bc5c80"
import script from "./SocialCounter.vue?vue&type=script&lang=js"
export * from "./SocialCounter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports